import { registerFlagInterceptors } from '@spotify/confidence-flag-evaluation-react';

import { markFlagContent } from '../highlight/markFlagContent';
import { impersonateEvaluationContext } from '../impersonation/impersonateEvaluationContext';
import { usePinnedDevbarFlag } from '../impersonation/usePinnedDevbarFlag';
import { useRecordFlagRead } from '../pageFlags/registry';

registerFlagInterceptors({
  value: [useRecordFlagRead, usePinnedDevbarFlag],
  evaluationContext: impersonateEvaluationContext,
  content: markFlagContent,
});
